import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { ref, set } from "firebase/database";
import PaymentMethod from "./PaymentMethod";
import { clearCart } from "../redux/winesSlice";
import database from "../firebase-config";
import { useNavigate } from "react-router-dom";
import "./CartResultBlock.css";

function CartResultBlock() {

  const cartItems = useSelector(state => state.wines.cart);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const minOrder = 50;
  const [totalAmount, setTotalAmount] = useState(0);
  const [freeDeliveryAmount, setFreeDeliveryAmount] = useState(50);
  const [sendedOrder, setSendedOrder] = useState(false);
  const [orderLimit, setOrderLimit] = useState(500);
  const [showOrderLimitPopup, setShowOrderLimitPopup] = useState(false);

  const handleAddMore = () => {
  if (cartItems.length === 0) return;

  const firstItem = cartItems[0].item;

  navigate(
    `/shopitem?mode=addmore&site_id=${firstItem.site_id}&cat_id=${firstItem.cat_id}&bm_id=${firstItem.bm_id}`
  );
};

  const handleCheckout = async () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (!isLoggedIn) {
      navigate("/login", { state: { from: "/cart" } });
      return;
    }

    if (totalAmount < orderLimit) {
      setShowOrderLimitPopup(true);
      return;
    }

    try {
      const mobile = localStorage.getItem("userMobile"); // Change if you store it elsewhere
      console.log("Cart Items:", cartItems);

      cartItems.forEach((cart, index) => {
        console.log("Item", index);
        console.log(cart.item);
      });
      const cart_items = cartItems.map((cart) => ({
        site_id: String(cart.item.site_id),
        cat_id: String(cart.item.cat_id),
        bm_id: String(cart.item.bm_id),

        b_q: cart.item.selectedSize === "750ML" ? String(cart.amount) : "0",
        b_p: cart.item.selectedSize === "375ML" ? String(cart.amount) : "0",
        b_n: cart.item.selectedSize === "180ML" ? String(cart.amount) : "0",

        amount: (
          Number(cart.amount) *
          Number(cart.item.selectedRate)
        ).toString(),
      }));
      console.log("Mobile:", mobile);
      console.log({
        mobile,
        cart_items,
      });

  const response = await fetch(
  "https://gitstool.in/liquor/shop_app/create_order.php",
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      mobile,
      cart_items,
    }),
  }
);

const text = await response.text();
console.log(text);

// Find the first JSON object
const jsonStart = text.indexOf("{");
const data = JSON.parse(text.substring(jsonStart));

if (data.status === "success") {
  const options = {
    key: data.key,
    amount: data.amount,
    currency: data.currency,
    name: "DSIIDC",
    description: "Order Payment",
    order_id: data.razorpay_order_id,

    handler: async function (response) {

    try {

      console.log("Payment Success");
      console.log(response);

      const verifyResponse = await fetch(
        "https://gitstool.in/liquor/shop_app/verify_payment_details.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            payment_id: response.razorpay_payment_id,
          }),
        }
      );

      const text = await verifyResponse.text();
      console.log("Verify Response:", text);

      const verifyData = JSON.parse(text);

      console.log("Verify Payment Response");
      console.log(verifyData);

      if (verifyData.status === "captured") {

        navigate("/order-success", {
          state: {
            order_id: verifyData.notes.receipt,
            uid_no: verifyData.notes.ref_no,
            dlv_dt: verifyData.notes.delivery_date,
            amount: `₹ ${verifyData.amount}`,
          },
        });

      } else {

        alert(
          verifyData.error_description ||
          "Payment verification failed."
        );

      }

    } catch (err) {

      console.error(err);

      alert("Unable to verify payment.");

    }

  },

    prefill: {
      contact: mobile,
    },

    theme: {
      color: "#B71C1C",
    },

    modal: {
      ondismiss: function () {
        console.log("Payment cancelled");
      },
    },
  };

 const rzp = new window.Razorpay(options);

rzp.on("payment.failed", function (response) {
  console.log("Payment Failed");
  console.log(response);

  console.log("Code:", response.error.code);
  console.log("Description:", response.error.description);
  console.log("Reason:", response.error.reason);
  console.log("Source:", response.error.source);
  console.log("Step:", response.error.step);
  console.log("Metadata:", response.error.metadata);

  alert(response.error.description);
});

rzp.open();
}

  } catch (err) {
    console.error(err);
    alert("Unable to create order");
  }
};
  useEffect(() => {
  if (cartItems.length > 0) {
    const amount = cartItems.reduce((total, cartItem) => {
      const price = Number(cartItem.item.selectedRate || 0);
      return total + cartItem.amount * price;
    }, 0);

    setTotalAmount(amount);
    setFreeDeliveryAmount(Math.max(minOrder - amount, 0));
  } else {
    setTotalAmount(0);
    setFreeDeliveryAmount(minOrder);
  }
}, [cartItems]);
function sendOrder() {
     const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (!isLoggedIn) {
      navigate("/login", { state: { from: "/cart" } });
      return;
    }

    const order = cartItems.map(v => ({
      name: v.item.name,
      id: v.item.id,
      amount: v.amount,
    }));

    uploadOrderToServer(order);
    dispatch(clearCart());
    setTotalAmount(0);
    setFreeDeliveryAmount(0);
    setSendedOrder(true);
  }

  useEffect(() => {
  async function fetchOrderLimit() {
    try {
      const response = await fetch(
        "https://gitstool.in/liquor/shop_app/order_setting.php"
      );

      const data = await response.json();

      if (data.status === "success") {
        setOrderLimit(Number(data.order_limit));
      }
    } catch (err) {
      console.error("Unable to fetch order limit", err);
    }
  }

  fetchOrderLimit();
}, []);

  async function uploadOrderToServer(order) {
    const id = new Date();
    set(ref(database, 'orders/' + id), order);
  };

  return (
    <>
    {(cartItems.length !== 0 || sendedOrder) && (
      <div className="cart-result-wrap">
        <div className="cart-result-decorate-line"></div>
      { cartItems.length !== 0 &&(
        <div className="cart-result-block">
          
          <div className="cart-result-block-info">
            <div className="cart-result-block-title">
              <span className="total-label">Total:</span>
              <span className="total-price">₹ {totalAmount.toFixed(2)}</span>
            </div>
            {/*{ (totalAmount < minOrder) && 
              <p className="cart-result-block-par">
                Not enough to get free shipping:
                <span> ₹{freeDeliveryAmount.toFixed(2)}</span>
              </p>
            }*/}
          </div>
<div className="cart-buttons-row">

  <input
    className="cart-result-block-btn"
    type="button"
    value="Checkout"
    onClick={handleCheckout}
  />

</div>   
</div>
      )}

      { (sendedOrder) &&
        <p className="cart-result-block-response">Thank you, your order has been accepted!</p>
      }
</div>
    )}
      { cartItems.length === 0 && !sendedOrder &&(
         <div className="cart-result-wrap1">
         <div className="cart-result-empty">
        <div className="cart-result-empty-img-block"></div>
        <h2 className="cart-result-empty-title">
          cart empty
        </h2>
        <NavLink to="/shop" className="cart-result-empty-link">Choose wine</NavLink>
        </div>
        </div>
      )}

      {/* Minimum Order Popup */}
      {showOrderLimitPopup && (
        <div className="order-limit-popup-overlay">
          <div className="order-limit-popup">
              
            <h2>Minimum Order Amount</h2>

            <p>
              The minimum order amount is
              <strong> ₹{orderLimit.toFixed(2)}</strong>.
            </p>

            <p>Please add more items to continue.</p>

            <button
              onClick={() => setShowOrderLimitPopup(false)}
            >
              OK
            </button>

          </div>
        </div>
      )}
  </>
  );
}
export default CartResultBlock;